import React from 'react'

// HOC for injecting a Cache-Control: no-store header into a page route
const withNoCachePage = (Page) => {
  class WithNoCachePage extends React.Component {
    static displayName = `withNoCachePage(${Page.displayName || Page.name || 'Page'})`

    static async getInitialProps(ctx) {
      // override the response with a Cache-Control: no-store header
      if (ctx && ctx.res != null) {
        ctx.res.setHeader('Cache-Control', 'no-store')
      }

      let initialProps = {}
      if (Page.getInitialProps) {
        initialProps = await Page.getInitialProps(ctx)
      }

      return {
        ...initialProps,
      }
    }

    render() {
      const { ...pageProps } = this.props
      return (
        <Page {...pageProps} />
      )
    }
  }

  return WithNoCachePage
}

export default withNoCachePage
